import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7mrrycec9d: FaireBrandEntity = {
  token: "b_7mrrycec9d",
  type: "brand",
  name: "KT Supply",
  avatarUrl:
    "https://cdn.faire.com/fastly/7efb010eec3d674e2f26bdc45d770d20721d8fa8b4130f118bd3a22c87ecbe58.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6580d7809918ae0638d7a32b8683d658ea96ba8cbfff4abd0a26ed9c502ff265.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7efb010eec3d674e2f26bdc45d770d20721d8fa8b4130f118bd3a22c87ecbe58.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6580d7809918ae0638d7a32b8683d658ea96ba8cbfff4abd0a26ed9c502ff265.jpeg",
  location: "Moonachie, NJ, USA",
  minimumOrderDollars: 140,
  rating: 4.2,
  reviewCount: 26,
  isInsider: true,
  description:
    "Now we are completely settled in new location\n\nFulfillment is back to normal. \n\nAll orders will ship within 5–10 business days.\nSome orders may require 10–15 business days to ship, as we process orders in the order they were received",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:50.869Z",
    importedBy: "entity-db-cli",
  },
};
